import React, { FC, useEffect } from 'react';
import {
  useSearchParams,
  useNavigate,
  useOutletContext,
} from 'react-router-dom';
import { DefaultBasePage } from '@components';
import { SectionType } from '@fdha/web-ui-library';
import { DeliveryStatus } from '@fdha/graphql-api-patient';

import ChooseMeals from '../../../components/meals/ChooseMeals/ChooseMeals';
import { MealDeliveryContextData } from '../../../components/meals/MealsLayout';

const ChooseMealsPage: FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { deliveryId, headerTitle, isCanceled, deliveryStatus } =
    useOutletContext<MealDeliveryContextData>();

  const itemType =
    (searchParams.get('itemType') as SectionType) || 'entreeDishes';

  const goToReviewScreen = () => {
    navigate(`/meals/${deliveryId}`);
  };

  // Navigate back if delivery is cancelled or closed
  useEffect(() => {
    const isDeliveryClosed = deliveryStatus === DeliveryStatus.Closed;

    if (isCanceled || isDeliveryClosed) {
      navigate(`/meals/${deliveryId}`, { replace: true });
    }
  }, [isCanceled, deliveryStatus, deliveryId, navigate]);

  return (
    <DefaultBasePage
      title="Choose Meals"
      i18nKeyTitle="meals:chooseMeals.pageTitle"
      parentRouteName={{
        text: headerTitle.fallback,
      }}
      contentSize="large"
    >
      <ChooseMeals
        deliveryId={deliveryId}
        itemType={itemType}
        goToReviewScreen={goToReviewScreen}
      />
    </DefaultBasePage>
  );
};

export default ChooseMealsPage;
